import {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { z } from 'zod';

import { signInSuccess } from './session-slice';

const refreshResponseValidator = z.object({
    access_token: z.string(),
    refresh_token: z.string(),
});

let refreshPromise: Promise<boolean> | null = null;

export const persistAuthTokens = (tokens: {
    accessToken: string;
    refreshToken: string;
}) => {
    localStorage.setItem('auth', JSON.stringify(tokens));
};

export const clearAuthTokens = () => {
    localStorage.removeItem('auth');
};

export const refreshSession = async (
    refreshToken: string,
    api: Parameters<BaseQueryFn>[1],
    extraOptions: Parameters<BaseQueryFn>[2],
    refreshAccessToken: (
        refreshToken: string,
        api: Parameters<BaseQueryFn>[1],
        extraOptions: Parameters<BaseQueryFn>[2],
    ) => ReturnType<
        BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>
    >,
) => {
    if (!refreshPromise) {
        refreshPromise = Promise.resolve(
            refreshAccessToken(refreshToken, api, extraOptions),
        )
            .then((refreshResult) => {
                if (!refreshResult?.data) {
                    console.error('Failed to refresh access token.');
                    return false;
                }

                const parsedData = refreshResponseValidator.safeParse(
                    (refreshResult.data as any)?.data,
                );

                if (!parsedData.success) {
                    console.error('Invalid refresh response');
                    return false;
                }

                const tokens = {
                    accessToken: parsedData.data.access_token,
                    refreshToken: parsedData.data.refresh_token,
                };

                persistAuthTokens(tokens);
                api.dispatch(signInSuccess(tokens));

                return true;
            })
            .catch((error) => {
                console.error('Error refreshing access token:', error);
                return false;
            })
            .finally(() => {
                refreshPromise = null;
            });
    }

    return refreshPromise;
};
